define('../app/fukit/model/person.model',['require','exports','module','./admin.base.model'],function(require, exports, module) {
  var AdminBaseModel = require('./admin.base.model');

  var PersonModel = AdminBaseModel.extend({
    radioRequests: {
      'models Person': '@constructor',
      'models PersonModel': '@constructor',
    },

    virtual: {
      fullName: {
        deps: ['firstName', 'lastName'],
        get: function() {
          var joiningString = this.get('firstName') && this.get('lastName') ? ' ' : '';

          return (this.get('firstName') || '') + joiningString + (this.get('lastName') || '');
        },
      },
    },

    urlRoot: AdminBaseModel.prototype.baseUrlRoot + '/person',
  });

  module.exports = PersonModel;
});

